/* ─────────────────────────────────────────────────────────────
   거리 / 도보 시간 계산 유틸
   ───────────────────────────────────────────────────────────── */

const EARTH_RADIUS_M = 6371000;
const WALK_SPEED_MPS = 1.2; // 약 4.3 km/h (일상 보행)
const CAR_SPEED_MPS = 6.94; // 약 25 km/h (시내 주행 평균)

/** 두 좌표 사이 직선 거리 (m) - Haversine */
export function haversineDistanceM(lat1, lng1, lat2, lng2) {
  if (lat1 == null || lat2 == null) return null;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_M * c;
}

/** 직선거리(m) → 도보 분 (최소 1분) */
export function walkMinutes(distM) {
  if (distM == null) return null;
  return Math.max(1, Math.round(distM / WALK_SPEED_MPS / 60));
}

/** 직선거리(m) → 차로 분 (최소 1분). 시내 25km/h 기준 — 도로 경로는 아님 */
export function carMinutes(distM) {
  if (distM == null) return null;
  return Math.max(1, Math.round(distM / CAR_SPEED_MPS / 60));
}

/** 사람이 읽기 좋은 거리 문자열 */
export function formatDistance(distM) {
  if (distM == null) return "";
  if (distM < 1000) return `${Math.round(distM)}m`;
  return `${(distM / 1000).toFixed(1)}km`;
}

/** 사람이 읽기 좋은 소요시간 문자열 — "N분" 또는 "N시간 N분" 또는 "N시간" */
export function formatDuration(seconds) {
  if (seconds == null) return "";
  const totalMin = Math.max(1, Math.round(seconds / 60));
  if (totalMin < 60) return `${totalMin}분`;
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return m === 0 ? `${h}시간` : `${h}시간 ${m}분`;
}

/** 직선거리(m) → 도보 시간 문자열 ("N분" / "N시간 N분") */
export function walkDurationText(distM) {
  if (distM == null) return "";
  return formatDuration(distM / WALK_SPEED_MPS);
}

/** 직선거리(m) → 차량 시간 문자열 */
export function carDurationText(distM) {
  if (distM == null) return "";
  return formatDuration(distM / CAR_SPEED_MPS);
}
